import { normalizePlanName } from "../../utils/planFeatureAccess";

export const selectCurrentPlan = (state) =>
  normalizePlanName(state.auth.currentPlan || "trial");